module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1522-42c4c04a9a5fa6d32666e6e1cfb0728f.png";